import type { MetricUnit } from './metrics.js';
import type { Operator } from './operators.js';

const integer = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
const oneDecimal = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 1 });
const twoDecimals = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });

/** Human-readable value for a metric, e.g. "72.4%", "1,204", "Up". */
export function formatMetricValue(unit: MetricUnit, value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  switch (unit) {
    case 'percent':
      return `${oneDecimal.format(value)}%`;
    case 'count':
      return integer.format(value);
    case 'state':
      return value >= 1 ? 'Up' : 'Down';
    case 'number':
      return twoDecimals.format(value);
  }
}

const OPERATOR_WORDS: Record<Operator, string> = {
  '<': 'below',
  '<=': 'at or below',
  '>': 'above',
  '>=': 'at or above',
  '==': 'equal to',
  '!=': 'not equal to',
};

/** Plain-language rule condition, e.g. "Connected devices below 800", "Server reachable is Down". */
export function describeCondition(
  label: string,
  unit: MetricUnit,
  operator: Operator,
  threshold: number,
): string {
  if (unit === 'state') {
    const breachedWhenDown = (operator === '==' && threshold === 0) || (operator === '!=' && threshold === 1);
    return `${label}: ${breachedWhenDown ? 'Down' : `${operator} ${threshold}`}`;
  }
  return `${label} ${OPERATOR_WORDS[operator]} ${formatMetricValue(unit, threshold)}`;
}
